import MarkdownIt from 'markdown-it'

// 对路径中的中文字符进行URL编码
function encodePath (path) {
  if (!path) return path
  return path.split('/').map(segment => {
    if (!segment) return segment
    return segment.replace(/[^A-Za-z0-9\-._~:/?#[\]@!$&'()*+,;=%]/g, function (ch) {
      return encodeURIComponent(ch)
    })
  }).join('/')
}

// 与管理员端 MarkdownEditor.vue 完全一致的 markdown-it 配置
const md = new MarkdownIt({
  html: false,
  breaks: true,
  linkify: false,
  typographer: false
})

// 自定义图片渲染：懒加载 + 加载失败隐藏 + 样式（与管理员预览一致）
md.renderer.rules.image = function (tokens, idx, options, env, self) {
  const token = tokens[idx]
  let src = token.attrGet('src') || ''
  // 处理相对路径：补全 baseUrl
  if (env && env.baseUrl && src && !src.startsWith('http') && !src.startsWith('data:')) {
    src = src.startsWith('/') ? env.baseUrl + src : env.baseUrl + '/' + src
  } else if (src && !src.startsWith('/') && !src.startsWith('http') && !src.startsWith('data:')) {
    src = '/' + src
  }
  // 编码中文字符
  src = encodePath(src)
  const alt = token.content || ''
  return `<img src="${src}" alt="${alt}" loading="lazy"
    style="max-width:100%;border-radius:4px"
    onerror="(function(){if(this.src.indexOf('.png')!==-1&&!this._retried){this._retried=1;this.src=this.src.replace(/.png/,'.jpg')}else{this.style.display='none'}})()">`
}

/**
 * 渲染 Markdown 为 HTML
 * @param {string} markdown - Markdown 文本
 * @param {string} baseUrl - 图片域名前缀（可选）
 * @returns {string} HTML 字符串
 */
export function renderMarkdown (markdown, baseUrl) {
  if (!markdown) return ''
  try {
    return md.render(markdown, { baseUrl })
  } catch (e) {
    return `<pre>${escapeHtml(markdown)}</pre>`
  }
}

function escapeHtml (str) {
  if (!str) return ''
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

export default { renderMarkdown }
